import { render, staticRenderFns } from "./addInGame.vue?vue&type=template&id=c78af020&"
import script from "./addInGame.vue?vue&type=script&lang=js&"
export * from "./addInGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c78af020')) {
      api.createRecord('c78af020', component.options)
    } else {
      api.reload('c78af020', component.options)
    }
    module.hot.accept("./addInGame.vue?vue&type=template&id=c78af020&", function () {
      api.rerender('c78af020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/announcement/components/addInGame.vue"
export default component.exports